module.exports = __webpack_public_path__ + "img/mobile_product2.6f419552.png";